/**
 * NAVIGATION.JS
 *
 * Initialization and control for the header menu on desktop and mobile.
 */

import * as GLOBALS from "../globals";
import InitHighlightedNavigation from "./navigation-highlight";
import Toggle from "../classes/toggle";
import Slideable from "../classes/slideable";

/**
 * @return {boolean} successful?
 */
export default function InitHeadermenu() {
	const headermenu = document.querySelector(".headermenu");

	if (headermenu === null) return report("Headermenu does not exist.");

	const navigationList = headermenu.querySelector("nav");

	if (navigationList === null || navigationList.childElementCount === 0) return report("Headermenu navigation does not exist or has no children.");

	if (GLOBALS.ENABLE_DROPDOWN_MENU) {
		InitDropdownMenu(headermenu);
	}

	if (GLOBALS.ENABLE_HIGHLIGHTED_NAVIGATION) {
		InitHighlightedNavigation(navigationList);
	}

	if (GLOBALS.ENABLE_TRANSPARENT_HEADER) {
		InitTransparentHeader(headermenu);
	}

	return true;
}

/**
 * Initializes the mobile dropdown menu buttons to toggle between open/closed.
 *
 * @return {boolean} successful?
 */
function InitDropdownMenu(headermenu) {
	const elements = headermenu.querySelectorAll(".nav-item.has-children");

	if (elements.length === 0) return report("There were no dropdown menus found.");

	elements.forEach((navItem) => {
		var dropdown = new Slideable(navItem.querySelector(".dropdown"));
		new Toggle(navItem.querySelector("button"), () => {
			dropdown.toggle();
		});
	});
}

/**
 * Initializes the functionality for the header menu to be transparent at the top of the page and get opaque once the user scrolled down a bit
 *
 * @param {Element} headermenu
 */
function InitTransparentHeader(headermenu) {
	if (window.innerWidth < GLOBALS.BREAKPOINT_LG || document.querySelectorAll(".error-page").length > 0) return;

	const changeBasedOnScrollOffset = () => {
		let scrollTop = document.documentElement.scrollTop;

		if (scrollTop > window.innerHeight * 0.5) {
			headermenu.classList.remove("headermenu-transparent");
		} else headermenu.classList.add("headermenu-transparent");
	};

	window.addEventListener("scroll", changeBasedOnScrollOffset);

	changeBasedOnScrollOffset();
}

function report(message) {
	console.error("Navigation: " + message);

	return false;
}

function log(message) {
	console.debug("Navigation: " + message);

	return false;
}
